import { Suspense } from 'react'
import { Outlet, useLoaderData } from 'react-router-dom'
import { ErrorBoundary } from '@sentry/react'
import { PhotoContextProvider } from '@jotta/photos/provider'
import { ErrorPage } from '@jotta/ui/ErrorPage'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'

import type { rootLoader } from './rootLoader'
import { useTracking } from './useTracking'
import { useNewVersionToast } from './useNewVersionToast'

export function Root() {
  useTracking()
  useNewVersionToast()

  const { redirectToAutoLogin } = useLoaderData() as Awaited<
    ReturnType<typeof rootLoader>
  >
  return (
    <ErrorBoundary
      fallback={({ error, resetError }) => (
        <ErrorPage error={error} resetError={resetError} />
      )}
      beforeCapture={scope =>
        scope
          .setExtra('dimensions', {
            width: window.innerWidth,
            height: window.innerHeight,
          })
          .setTag('section', 'root')
      }
    >
      <PhotoContextProvider>
        <Suspense fallback={<LoadingOverlay id="Root" open />}>
          {redirectToAutoLogin ? <LoadingOverlay id="Root" open /> : <Outlet />}
        </Suspense>
      </PhotoContextProvider>
    </ErrorBoundary>
  )
}
